// src/utils/weight.js

export const getMenuItemsWeights = (t) => {
  const weights = [];
  for (let i = 1; i <= 30; i += 0.5) {
    const weight = Math.round(i * 10) / 10;
    weights.push({ id: weight.toString(), name: `${weight} ${t("kg")}` });
  }
  weights.push({ id: "31", name: t("_>30 Kg") });
  return weights;
};
